import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export const useSearchScroll = () => {
  const location = useLocation();
  const navigationType = useNavigationType(); // 'PUSH', 'POP', or 'REPLACE'

  // 1. Restore scroll on page load (server-side reload support)
  useEffect(() => {
    if (location.pathname === '/search') {
      const savedScroll = sessionStorage.getItem('searchScroll');

      if (savedScroll) {
        setTimeout(() => {
          window.scrollTo(0, parseInt(savedScroll, 10));
        }, 0);
      }
    }
  }, []); // Run only once on mount (server-side support)

  // 2. React Router client-side navigation scroll handling
  useEffect(() => {
    if (location.pathname === '/search') {
      const savedScroll = sessionStorage.getItem('searchScroll');

      if (navigationType === 'POP' && savedScroll) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            window.scrollTo(0, parseInt(savedScroll, 10));
          });
        });
      } else {
        window.scrollTo(0, 0);
      }
    }
  }, [location.pathname, navigationType, location.state]);

  // 3. Save scroll position continuously on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (location.pathname === '/search') {
        sessionStorage.setItem('searchScroll', `${window.scrollY}`);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);
};
